export function getRankColor(rank) {
  if (rank === null || rank === undefined) return '#EF4444';
  if (rank <= 3)  return '#00C48C';
  if (rank <= 10) return '#60A5FA';
  return '#F59E0B';
}

export function getRankLabel(rank) {
  if (rank === null || rank === undefined) return 'Not Ranked';
  if (rank <= 3)  return 'Top 3';
  if (rank <= 10) return 'Page 1';
  return 'Page 2+';
}

export function getRankBgClass(rank) {
  if (rank === null || rank === undefined) return 'bg-[#EF4444]/10 text-[#EF4444] border-[#EF4444]/20';
  if (rank <= 3)  return 'bg-[#00C48C]/10 text-[#00C48C] border-[#00C48C]/20';
  if (rank <= 10) return 'bg-[#60A5FA]/10 text-[#60A5FA] border-[#60A5FA]/20';
  return 'bg-[#F59E0B]/10 text-[#F59E0B] border-[#F59E0B]/20';
}

export function getRankChange(current, previous) {
  if (previous === null || previous === undefined) return { direction: 'new',  delta: 0, label: 'New' };
  if (current  === null || current  === undefined) return { direction: 'down', delta: 0, label: 'Lost ranking' };

  const delta = previous - current; // positive = improved (rank number went down)

  if (delta > 0) return { direction: 'up',   delta,      label: `+${delta}` };
  if (delta < 0) return { direction: 'down', delta: -delta, label: `${delta}` };
  return { direction: 'flat', delta: 0, label: 'No change' };
}
